'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.sa_reboot', {
    url: '/company/:company_id/sa_reboot',
    template: '<oem-sa-reboot></oem-sa-reboot>'
  });
}



// WEBPACK FOOTER //
// ./public/dev/app/sa_reboot/oem/sa_reboot.routes.js